'use client';

import { useEffect, useState } from 'react';

import env, { isDeveloperMode } from 'config/env';
import { MOCK_CATALOG_PATH } from 'config/internalUrlPaths';

import { Banner, BannerText, CatalogLink } from './DemoModeBanner.styled';

const DemoModeBanner = () => {
  // The banner shows for anyone in mocked mode (including demo customers). The catalog link is a
  // developer-only tool, so it is revealed after mount only when isDeveloperMode() (localhost).
  const [showCatalogLink, setShowCatalogLink] = useState(false);

  useEffect(() => {
    setShowCatalogLink(isDeveloperMode());
  }, []);

  if (!env.MOCKED) {
    return null;
  }

  return (
    <Banner>
      <BannerText variant="body1">Demo mode</BannerText>
      {showCatalogLink && <CatalogLink href={MOCK_CATALOG_PATH}>Mock catalog</CatalogLink>}
    </Banner>
  );
};

export default DemoModeBanner;
